import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import makeStyles from '@material-ui/styles/makeStyles';
import * as React from 'react';

const useStyles = makeStyles({
  iconStyle: {
    fill: 'none',
    '&>path': {
      stroke: 'currentColor',
    },
  },
});

function DatabaseIcon(props: SvgIconProps) {
  const classes = useStyles();
  return (
    <SvgIcon className={classes.iconStyle} {...props}>
      <path
        d="M12 8c4.97 0 9-1.343 9-3s-4.03-3-9-3-9 1.343-9 3 4.03 3 9 3zM21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

const MemoDatabaseIcon = React.memo(DatabaseIcon);
export default MemoDatabaseIcon;
